<template>
  <div>
    <banner />
    <section id="main-container" class="main-container">
      <div class="container">
        <div class="row">
          <services-navigation
            :buildingActive="buildingActive"
            :paintingingActive="paintingingActive"
            :electricalActive="electricalActive"
            :landscapingActive="landscapingActive"
            :plumbingActive="plumbingActive"
            :tilingActive="tilingActive"
            :swimmingActive="swimmingActive"
            :aluminiumActive="aluminiumActive"
            :carpentryActive="carpentryActive"
            :fabricationActive="fabricationActive"
            :householdActive="householdActive"
            :architecturalActive="architecturalActive"
            :ceilingDesignlActive="ceilingDesignlActive"
            :renovationsActive="renovationsActive"
            :stoneCladdingActive="stoneCladdingActive"
          />
          <div class="col-lg-9 col-md-9 col-sm-12">
            <div class="content-inner-page">
              <div
                id="page-slider"
                class="owl-carousel owl-theme page-slider page-slider-small"
              >
                <div class="item" v-for="picture in pictures" :key="picture.id">
                  <img :src="`${baseURL}${picture.name}`" alt="" />
                  <div class="page-slider-caption">
                    <h3>
                      {{ picture.title }},
                      <span>{{ picture.location }}</span>
                    </h3>
                  </div>
                </div>
              </div>
              <h2 class="border-title border-left">{{ serviceTitle }}</h2>
              <div class="row">
                <div class="col-md-12">
                  <p>
                    {{ serviceDescription }}
                  </p>
                </div>
              </div>
              <why-us />
              <get-service-quote />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Banner from "@/components/common/Banner.vue";
import ServicesNavigation from "./ServicesNavigation";
import GetServiceQuote from "./GetServiceQuote";
import WhyUs from "./WhyUs";

export default {
  name: "ServicesView",
  components: {
    Banner,
    ServicesNavigation,
    WhyUs,
    GetServiceQuote
  },
  metaInfo: {
    title: "Services",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "description",
        content:
          "Johnson styles construction offers the following services in Zambia and across the word  Building services, Painting services, Electrical Wiring & Maintenance services, Landscaping & Paving services, Plumbing, Tilling services, Swimming pool construction services, aluminium fabrication & installation services, Carpentery & roofing services, Steel fabrication services, Household fittings services, Architectural & foundation setting services, Ceiling design and installation services, General renovations services, Stone cladding & raven services"
      }
    ]
  },
  data: () => ({
    baseURL:
      "https://res.cloudinary.com/codeselect/image/upload/v1565889771/johnsonthebuilder/"
  }),
  props: {
    pictures: {
      type: Array,
      default: () => []
    },
    serviceDescription: {
      type: String,
      default: ""
    },
    serviceTitle: {
      type: String,
      default: ""
    },
    buildingActive: {
      type: String,
      default: ""
    },
    paintingingActive: {
      type: String,
      default: ""
    },
    electricalActive: {
      type: String,
      default: ""
    },
    landscapingActive: {
      type: String,
      default: ""
    },
    plumbingActive: {
      type: String,
      default: ""
    },
    tilingActive: {
      type: String,
      default: ""
    },
    swimmingActive: {
      type: String,
      default: ""
    },
    aluminiumActive: {
      type: String,
      default: ""
    },
    carpentryActive: {
      type: String,
      default: ""
    },
    fabricationActive: {
      type: String,
      default: ""
    },
    householdActive: {
      type: String,
      default: ""
    },
    architecturalActive: {
      type: String,
      default: ""
    },
    ceilingDesignlActive: {
      type: String,
      default: ""
    },
    renovationsActive: {
      type: String,
      default: ""
    },
    stoneCladdingActive: {
      type: String,
      default: ""
    }
  }
};
</script>
